import React from 'react'
import CarouselContainer from '../layout/CarouselContainer'

function HomePage() {
    return (
        <div>
            <CarouselContainer/>
            
        </div>
    )
}

export default HomePage
